module.exports = __webpack_public_path__ + "static/img/infoAi.da949ec1.png";